<template>
  <div class="form">
    <OurGroups>
      <OurGroup class="form-group">
        <OurInput
          v-model="form.nameContains"
          :label="$t('label.title')"
          :placeholder="$t('placeholder.title')"
        />

        <OurSelect
          v-model="form.isActive"
          :label="$t('label.status')"
          :placeholder="$t('placeholder.selectStatus')"
          :options="getStatuses"
          item-label="text"
          value-key="value"
        />

        <PaginationSelect
          v-model="form.parentId"
          :options="parentCategories"
          :label="$t('categories.parentCategory')"
          :placeholder="$t('placeholder.selectParentCategory')"
          :options-limit="parentCategories?.length"
          :internal-pagination="false"
          :pagination-current-page="currentPage"
          item-label="name"
          @load-more="loadMore"
          @search-change="searchChange"
          @close="onClose"
          @clear="onClear"
        />

        <OurSelect
          v-model="form.forNotice"
          :label="$t('categories.canUseShort')"
          :placeholder="$t('placeholder.chooseFromList')"
          :options="getCanUseFilterOptions"
          item-label="text"
          value-key="value"
        />
      </OurGroup>
    </OurGroups>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { catalogCategoriesQuery } from "@/gql/catalog-categories.queries";
import apolloMixin from "@/mixins/apollo.mixin";
import PaginationSelect from "@/ui/select/PaginationSelect.vue";

export default {
  name: "CategoriesFilterForm",

  components: {
    PaginationSelect,
  },

  mixins: [apolloMixin],

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      form: {
        nameContains: "",
        isActive: null,
        parentId: null,
        forNotice: null,
      },
      parentCategories: [],
      parentCategoriesPaginatorInfo: {},
      currentPage: 1,
    };
  },

  computed: {
    ...mapGetters("categories", ["getStatuses", "getCanUseFilterOptions"]),
  },

  watch: {
    value: {
      handler: "setForm",
      deep: true,
    },
  },

  mounted() {
    this.setForm();
    this.getParentCategories(this.currentPage);
  },

  methods: {
    setForm() {
      this.form = this.value;
    },

    async getParentCategories(page, query = "") {
      const { catalogCategories } = await this.$get(
        catalogCategoriesQuery,
        {
          page,
          filters: {
            nameContains: query,
          },
        },
        { withLoader: false }
      );

      const { data, paginatorInfo } = catalogCategories;

      this.parentCategories =
        paginatorInfo.currentPage > 1 ? [...this.parentCategories, ...data] : data;
      this.parentCategoriesPaginatorInfo = catalogCategories.paginatorInfo;
    },

    loadMore(page) {
      const { currentPage, lastPage } = this.parentCategoriesPaginatorInfo;

      if (currentPage === lastPage) return;

      this.currentPage = page + 1;
      this.getParentCategories(page + 1);
    },

    searchChange(query) {
      if (!query) return;

      this.getParentCategories(1, query);
    },

    onClear() {
      this.form.parentId = null;
    },

    onClose() {
      this.currentPage = 1;
      this.getParentCategories(1);
    },
  },
};
</script>
